// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"4747e537","187":"d0559ef1","419":"30edf8e4","563":"9117a184","787":"d1d4a2c2","942":"5c93d60a"}[chunkId] + ".chunk.js";
};